import React from "react";
import { Grid } from "@material-ui/core";
import { translate as t } from "../../../../infrastructure/translate/localization";
import SectionContentWrapper from "../../../../app/components/SectionContentWrapper";

export default function AnalyticsPage() {
  return (
    <main className="section">
      <Grid item xs={12}>
        <SectionContentWrapper title={t("analytics-section.reports")}>
          <div id="adhesion-block" />
        </SectionContentWrapper>
        {/* <SectionContentWrapper title={t("analytics-section.consumptions")}>
          <div id="consumptions-block" />
        </SectionContentWrapper> */}
      </Grid>
    </main>
  );
}
